import baseAPI from "../app/baseAPI";

export const ViewJobReducer = baseAPI.injectEndpoints({
  endpoints(builder) {
    return {
      // Fetch all jobs (mapped to '/list')
      fetchViewJobDetails: builder.query({
        query(jobStatus) {
          let url = "http://localhost:8080/api/jobs/list"; // Updated endpoint
          return {
            url,
            method: "GET",
            token: true,
          };
        },
        keepUnusedDataFor: 5,
        transformResponse: (responseData) => responseData,
      }),

      // Fetch job details by ID (mapped to '/{id}')
      fetchViewJobDetailsbyId: builder.query({
        query(id) {
          return {
            url: `http://localhost:8080/api/jobs/${id}`, // Updated endpoint
            method: "GET",
            token: true,
          };
        },
        keepUnusedDataFor: 5,
        transformResponse: (responseData) => responseData,
      }),

      // Update job status (mapped to '/{id}/status/update')
      updateJobStatus: builder.mutation({
        query(params) {
          return {
            url: `http://localhost:8080/api/jobs/${params.Id}/status/update`, // Updated endpoint
            method: "PATCH",
            token: true,
            body: {
              ...params.paramsData,
            },
          };
        },
        keepUnusedDataFor: 5,
        transformResponse: (responseData) => responseData,
      }),
    };
  },
});

export const {
  useFetchViewJobDetailsQuery,
  useUpdateJobStatusMutation,
  useFetchViewJobDetailsbyIdQuery,
} = ViewJobReducer;
